export default __webpack_public_path__ + "static/media/exit-modal-flex-plus.a41431ab.png";